/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */


(function () {
  'use strict';
  angular.module('vcclient')
    .component('clientlist', {
      restrict: 'E',
      bindings: {
        mode: '@?',
        clients: '<?',
        redirect: '@?'
      },
      templateUrl: 'vcclient/clientlist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'ClientHelper', '$state', 'vertxEventBusService',
        function ($log, $http, Rlog, ClientHelper, $state, vertxEventBusService) {
          let vm = this;

          vm.currentPage = 1;
          vm.pageSize = 20;
          vm.pageChanged = pageChanged;
          vm.goToRecord = goToRecord;
          vm.removeClient = removeClient;

          vm.$onInit = function () {
            // default mode is 'client', set to 'patient' for sprechstunde compatibility

            if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
              vm.mode = 'client';
            }

            $log.debug('debug - vm.redirect passed is:', vm.redirect);
            // TODO: figure out why automatically derived vm.redirect becomes unset again before use
            if (angular.isUndefined(vm.redirect) || vm.redirect === '' || vm.redirect === null) {
              if (vm.mode === 'patient') {
                vm.redirect = 'clientrecord.basicdata';
              } else {
                vm.redirect = 'clientrecord.basicdata';
              }
              $log.debug('debug - vm.redirect set to:', vm.redirect);
            }
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.clients)) {
              $log.debug('debug: clients loading from backend');

              let search = {};
              search.page = vm.currentpage;

              search.query = {};
              search.query.active = true;
              search.options = {};
              if (angular.isDefined(vm.pageSize)) {
                search.options.pagesize = vm.pageSize;
              }

              // not necessary if you want all of the fields
              search.options.fields = {
                _id: 1,
                created: 1,
                test: 1,
                type: 1,
                category: 1,
                iscompany: 1,
                'company.name': 1,
                'primarycontact.firstname': 1,
                'primarycontact.lastname': 1,
                'svdata.bdateat': 1,
              };
              let sort = {};

              // get special fields according to vcclient type
              if (vm.mode === 'patient') {
                // search.options.fields.svdata = 1;
                sort['primarycontact.lastname'] = 1;
              }
              else {
                // search.options.fields.companydata = 1;
                sort['companydata.companyname'] = 1;
              }
              search.options.sort = sort;

              ClientHelper.getAll(search, vm.mode).$then(function (clients) {
                vm.clients = clients;
                vm.totalItems = clients.$pageCount;
              });
            }
          };

          function pageChanged() {
            vm.clients.$refresh({page: vm.currentPage}).$then(function (clients) {
              vm.totalItems = clients.$pageCount;
            });
          }

          function removeClient(client) {
            client.active = false;
            client.$save();
          }

          function goToRecord(client, target) {
            // TODO: figure out why automatically derived vm.redirect becomes unset again before use
            $log.debug('debug - gotToRecord vm.redirect, vm.mode: ', vm.redirect, vm.mode);
            $log.debug('debug - gotToRecord target: ', target);
            $state.go(vm.redirect, {client: client, clientid: client._id, mode: vm.mode});
            /*                      if (vm.mode === 'patient') {
                                        $state.go(vm.redirect, {client: client, clientid: client._id, mode: vm.mode});
                                    } else {
                                        $state.go(vm.redirect, {client: client, clientid: client._id, mode: vm.mode});
                                    }*/
          }

          const patientsUpdateHandler = function (message) {
            $log.debug('debug: Patient update received: ', message);
            vm.clients.$refresh().$then(function () {
            }, function (error) {
              $log.error(error);
            });
          };

          const clientsUpdateHandler = function (message) {
            $log.debug('debug: Client update received: ', message);
            vm.clients.$refresh().$then(function () {
            }, function (error) {
               $log.error(error);
            });
          };

          vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
          vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
            vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
          };




        }] // controller
    }); // component

  // klammerfriedhof
}());